export default __webpack_public_path__ + "static/media/pillion-demo.a6524cec.mp3";